import { makeStyles } from "@material-ui/core/styles";
import SubscriptionForm from "./SubscriptionFrom";


const BottomSection = ({ sectionName }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div
                className={classes.title}
            >{`${sectionName || ''} Coming Soon!`}</div>
            <div className={classes.subTitle}>Get notified when we launch</div>
            <div className={classes.subscriptionWrapper}>
                <SubscriptionForm/>
            </div>
        </div>
    );
};

export default BottomSection;

const useStyles = makeStyles(() => ({
    hello:{
        border: '1px solid red'
    },
    root: {
        width: "100%",
        height: "50%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    title: {
        marginTop: 50,
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "32px",
        lineHeight: "49px",
        color: "#4B4B4B",
    },
    subTitle: {
        marginTop: 24,
        fontFamily: "Montserrat",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "23px",
        lineHeight: "24px",
        color: "#4B4B4B",
    },
    subscriptionWrapper: {
        marginTop: 35,
    }
}));
